/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Local Imports
*/

import { ValuedField } from './ValuedField';

/**
 * Exports
*/

/**
 * 
 */
export function HiddenField(props) {
  return (
    <ValuedField { ...props }>
      <input name={ props.name } type='hidden' />
    </ValuedField>
  );
}

HiddenField.propTypes = {
  name: PropTypes.string.isRequired,
  formik: PropTypes.object
};